import React, { Component } from 'react';
import moment from 'moment';
import Clamp from 'shiitake';
import classNames from 'classnames';
import { Icon } from 'ui';
import DateFormat from 'constants/date_format';

class ZendeskLibraryItem extends Component {
  constructor(props) {
    super(props);
    this.renderActive = this.renderActive.bind(this);
    this.renderInactive = this.renderInactive.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete() {
    this.props.deleteItem(this.props.item);
  }

  showDeleteIcon() {
    const { item, currentUserId } = this.props;
    const ownerOfContent = currentUserId === item.creator_id;

    return item.creator_id && ownerOfContent;
  }

  renderActive() {
    const { item, i18n, active } = this.props;
    const itemTitleClassName = classNames(
      'ElementLibraryItem-title fz-bigger',
      {
        'ElementLibraryItem--active fw-b': active,
      },
    );
    const itemDescriptionClassName = classNames('fz-bigger', {
      'ElementLibraryItem--active': active,
    });

    return (
      <div>
        <div className="d-f jc-sb ai-fs">
          <div>
            <span className={itemTitleClassName}>
              #{item.zendesk_id}: {item.subject}
            </span>
            {item.description && (
              <div className={itemDescriptionClassName}>{item.description}</div>
            )}
          </div>
          {this.showDeleteIcon() && (
            <span
              role="button"
              tabIndex={0}
              title={i18n.delete_tooltip}
              data-toggle="tooltip"
              data-placement="left"
              onClick={this.handleDelete}
              onKeyDown={e => e.key === 'Enter' && this.handleDelete()}
            >
              <Icon name="error" />
            </span>
          )}
        </div>
        <div className="ElementLibraryItem-additionalInfo mt-16">
          <div className="fw-b">
            {i18n.added}{' '}
            {moment(
              item.created_at,
              DateFormat.fixed.FULL_YEAR_MONTH_DATE_TIME,
            ).fromNow()}
            &nbsp;by {item.creator_name || i18n.anonymous}
            {item.creator_provided_description && (
              <span>
                &nbsp;
                {i18n.with_usage_note}:
              </span>
            )}
          </div>
          <div className="fz-base">{item.creator_provided_description}</div>
        </div>
      </div>
    );
  }

  renderInactive() {
    const { item, active, i18n } = this.props;
    const ticketHeader = `#${item.zendesk_id}: ${item.subject} - ${item.description}`;
    const itemTitleClassName = classNames(
      'ElementLibraryItem-title fz-bigger',
      {
        'ElementLibraryItem--active fw-b': active,
      },
    );

    return (
      <div>
        <Clamp lines={1} className={itemTitleClassName}>
          {ticketHeader}
        </Clamp>
        {item.creator_provided_description && (
          <div className="c-brand-gray-dark fz-base">
            {i18n.usage_note}:{item.creator_provided_description}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { active } = this.props;

    const elementLibraryItemClassName = classNames('ElementLibraryItem', {
      'ElementLibraryItem--active': active,
    });

    const infoClassName = classNames('ElementLibraryItem-info', {
      'd-f ai-c': !active,
    });

    return (
      <div
        onClick={() => this.props.onClick(this.props.item)}
        onKeyDown={e =>
          e.key === 'Enter' && this.props.onClick(this.props.item)
        }
        className={elementLibraryItemClassName}
      >
        <div className={infoClassName}>
          {!active && this.renderInactive()}
          {active && this.renderActive()}
        </div>
      </div>
    );
  }
}

export default ZendeskLibraryItem;
